















































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Timing from "@/data/furniture/Timing";
import DatePickerMenu from "../DatePickerMenu.vue";
import ConditionalDate from "./ConditionalDate.vue";

@Component({ components: { DatePickerMenu, ConditionalDate } })
export default class TimingDates extends Vue {
  @Prop()
  readonly value!: Timing;

  @Prop({ default: false })
  readonly readonly!: boolean;

  updateTiming(updates: Partial<Timing>): void {
    this.$emit("input", { ...this.value, ...updates });
  }

  get dateOffered(): string {
    return Timing.formatDate(this.value.dateOffered);
  }

  set dateOffered(value: string) {
    this.updateTiming({ dateOffered: value ? new Date(value) : undefined });
  }

  get pickupBy(): string {
    return Timing.formatDate(this.value.pickupBy);
  }

  set pickupBy(value: string) {
    this.updateTiming({ pickupBy: value ? new Date(value) : undefined });
  }

  get urgent(): boolean {
    return this.value.urgent;
  }

  set urgent(value: boolean) {
    this.updateTiming({ urgent: value });
  }

  get confirmedPickupDate(): string {
    return Timing.formatDate(this.value.confirmedPickupDate);
  }

  set confirmedPickupDate(value: string) {
    /* eslint-disable object-curly-newline */
    this.updateTiming({
      confirmedPickupDate: value ? new Date(value) : undefined,
    });
    /* eslint-enable object-curly-newline */
  }

  get dateCollected(): string {
    return Timing.formatDate(this.value.dateCollected);
  }

  set dateCollected(value: string) {
    this.updateTiming({ dateCollected: value ? new Date(value) : undefined });
  }

  get dateDelivered(): string {
    return Timing.formatDate(this.value.dateDelivered);
  }

  set dateDelivered(value: string) {
    this.updateTiming({ dateDelivered: value ? new Date(value) : undefined });
  }
}
